import React from 'react'
import SubPageHeader from '../components/subPageHeader'
import Plans from '../components/plans'

export default ({ title, description, background, url }) => (
  <SubPageHeader
    title={title}
    text={description}
    background={background}
    currentUrl={url}
    variant="Pricing"
  >
    <Plans />
  </SubPageHeader>
)
